<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>
      <!-- <Spinner ref="spinner"></Spinner> -->
      <v-form v-model="valid" @submit="editAccount" ref="editAccountForm">
        <v-layout text-xs-center>
          <v-flex mb-0 xs12 mx-2>
            <v-layout justify-start row mx-3 mt-3 align-center>
              <v-flex>
                <div
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >Edit Account # {{ this.account.BAN }}</div>
              </v-flex>
              <v-flex>
                <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end row>
                      <v-btn icon @click="cancel" class="pa-0 mr-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2 mb-3>
              <v-layout hide-details justify-start row mt-0 mb-4>
                <v-flex hide-details mx-4 xs2>
                  <!-- <h3 class="text-xs-left ml-0 mt-1" style="color: white"> - </h3> -->
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.Name1"
                    value="Name1"
                    label="Name 1*"
                    @input="forceUpperCase('Name1')"
                    :rules="Name1Rules"
                    required
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.Name2"
                    value="Name 2"
                    label="Name 2"
                    @input="forceUpperCase('Name2')"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.Address1"
                    value="Address1"
                    label="Address Line 1*"
                    @input="forceUpperCase('Address1')"
                    required
                    :rules="Address1Rules"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.Address2"
                    value="Address2"
                    label="Address Line 2"
                    @input="forceUpperCase('Address2')"
                  ></v-text-field>
                </v-flex>

                <v-flex hide-details mx-4 mr-5 xs2 style="margin-top: 20px;">
                  <h3 class="text-xs-left ml-0 mt-1" style="color: white;">-</h3>
                  <v-text-field
                    style="max-height: 45px; margin-top: 6px;"
                    v-model="account.cityName"
                    value="cityName"
                    label="City*"
                    @input="forceUpperCase('cityName')"
                    required
                    :rules="cityNameRules"
                  ></v-text-field>
                  <v-autocomplete
                    hide-details
                    :items="ddlStateProvs"
                    v-model="account.stateProvId"
                    item-text="Text"
                    item-value="Value"
                    label="State/Prov*"
                    clearable
                    @change="getMailCodeMask"
                    required
                    :rules="stateProvRules"
                  ></v-autocomplete>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.mailCode"
                    value="mailCode"
                    label="Postal/Zip Code*"
                    :mask="mailCodeMask"
                    return-masked-value
                    required
                    :rules="mailCodeRules"
                  ></v-text-field>
                </v-flex>

                <v-divider vertical class="mt-2 mb-1"></v-divider>

                <v-flex hide-details mx-4 ml-5 xs2>
                  <h3 class="text-xs-left ml-0 mt-1">Bill Payment</h3>
                  <v-autocomplete
                    hide-details
                    :items="ddlPaymentMethods"
                    v-model="account.paymentMethodId"
                    item-text="Text"
                    item-value="Value"
                    label="Payment Method*"
                    clearable
                    required
                    :rules="paymentMethodRules"
                  ></v-autocomplete>
                  <v-text-field
                    class="mt-4"
                    style="max-height: 45px"
                    v-model="account.ACH_BankName"
                    value="ACH_BankName"
                    label="Bank Name"
                    @input="forceUpperCase('ACH_BankName')"
                    v-show="account.paymentMethodId === 'AC'"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.ACH_BankAccountName"
                    value="ACH_BankAccountName"
                    label="Account Name*"
                    @input="forceUpperCase('ACH_BankAccountName')"
                    v-show="account.paymentMethodId === 'AC'"
                    :required="account.paymentMethodId === 'AC'"
                    :rules="(account.paymentMethodId === 'AC') ? ACH_BankAccountNameRules : []"
                  ></v-text-field>
                  <v-autocomplete
                    hide-details
                    :items="ddlCCTypes"
                    v-model="account.creditCardTypeId"
                    item-text="Text"
                    item-value="Value"
                    label="Credit Card Type*"
                    clearable
                    v-show="account.paymentMethodId === 'CC'"
                    :required="account.paymentMethodId === 'CC'"
                    :rules="(account.paymentMethodId === 'CC') ? CCTypeRules : []"
                  ></v-autocomplete>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.CardNumber"
                    value="CardNumber"
                    label="Credit Card Number*"
                    v-show="account.paymentMethodId === 'CC'"
                    @focus="addCreditCardMask"
                    :mask="creditCardHasMask ? creditCardMask : null"
                    :required="account.paymentMethodId === 'CC'"
                    :rules="(account.paymentMethodId === 'CC') ? CardNumberRules : []"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.CardholderName"
                    value="CardholderName"
                    label="Cardholder Name*"
                    @input="forceUpperCase('CardholderName')"
                    v-show="account.paymentMethodId === 'CC'"
                    :required="account.paymentMethodId === 'CC'"
                    :rules="(account.paymentMethodId === 'CC') ? CardholderNameRules : []"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="cardExpiryString"
                    value="CardExpiry"
                    label="Card Expiry (MM/YY)*"
                    v-show="account.paymentMethodId === 'CC'"
                    :mask="creditCardExpiryMask"
                    :required="account.paymentMethodId === 'CC'"
                    :rules="(account.paymentMethodId === 'CC') ? CardExpiryRules : []"
                  ></v-text-field>
                </v-flex>

                <v-flex hide-details mx-4 xs2>
                  <h3 class="text-xs-left ml-0 mt-1" style="color: white;">-</h3>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.CreditLimit"
                    value="CreditLimit"
                    label="Credit Limit*"
                    type="number"
                    required
                    :rules="CreditLimitRules"
                  ></v-text-field>
                  <v-text-field
                    class="mt-4"
                    style="max-height: 45px"
                    v-model="account.ACH_BankAccountNumber"
                    value="ACH_BankAccountNumber"
                    label="Account Number*"
                    type="number"
                    v-show="account.paymentMethodId === 'AC'"
                    :required="account.paymentMethodId === 'AC'"
                    :rules="(account.paymentMethodId === 'AC') ? ACH_BankAccountNumberRules : []"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.ACH_RoutingNumber"
                    value="ACH_RoutingNumber*"
                    label="Routing Number*"
                    type="number"
                    v-show="account.paymentMethodId === 'AC'"
                    :required="account.paymentMethodId === 'AC'"
                    :rules="(account.paymentMethodId === 'AC') ? ACH_RoutingNumberRules : []"
                  ></v-text-field>
                  <v-checkbox
                    v-show="account.paymentMethodId === 'CC'"
                    v-model="account.UseBillingAddress"
                    style="max-height: 34px; margin-top: 62px;"
                  >
                    <template v-slot:label>
                      <div>Use Account Billing Address</div>
                    </template>
                  </v-checkbox>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.CC_Address1"
                    value="CC_Address1"
                    label="Address Line 1*"
                    @input="forceUpperCase('CC_Address1')"
                    :disabled="account.UseBillingAddress"
                    v-show="account.paymentMethodId === 'CC'"
                    :required="!account.UseBillingAddress && account.paymentMethodId === 'CC'"
                    :rules="(!account.UseBillingAddress && account.paymentMethodId === 'CC') ? CC_Address1Rules : []"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.CC_Address2"
                    value="CC_Address2"
                    label="Address Line 2"
                    @input="forceUpperCase('CC_Address2')"
                    :disabled="account.UseBillingAddress"
                    v-show="account.paymentMethodId === 'CC'"
                  ></v-text-field>
                </v-flex>

                <v-flex hide-details mx-4 xs2>
                  <h3 class="text-xs-left ml-0 mt-1" style="color: white;">-</h3>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.Deposit"
                    value="Deposit"
                    label="Deposit ($)"
                    type="number"
                  ></v-text-field>
                  <v-text-field
                    class="mt-4"
                    style="max-height: 45px"
                    v-model="account.ACH_TransitNumber"
                    value="ACH_TransitNumber"
                    label="Transit Number"
                    type="number"
                    v-show="account.paymentMethodId === 'AC'"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.ACH_BankCode"
                    value="ACH_BankCode"
                    label="Bank Code"
                    v-show="account.paymentMethodId === 'AC'"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px; margin-top: 52px;"
                    v-model="account.CC_City"
                    value="CC_City"
                    label="City*"
                    @input="forceUpperCase('CC_City')"
                    :disabled="account.UseBillingAddress"
                    v-show="account.paymentMethodId === 'CC'"
                    :required="!account.UseBillingAddress && account.paymentMethodId === 'CC'"
                    :rules="(!account.UseBillingAddress && account.paymentMethodId === 'CC') ? CC_CityRules : []"
                  ></v-text-field>
                  <v-autocomplete
                    hide-details
                    :items="ddlStateProvs"
                    v-model="account.CC_stateProvId"
                    item-text="Text"
                    item-value="Value"
                    label="State/Prov*"
                    clearable
                    @change="getCCMailCodeMask"
                    :disabled="account.UseBillingAddress"
                    v-show="account.paymentMethodId === 'CC'"
                    :required="!account.UseBillingAddress && account.paymentMethodId === 'CC'"
                    :rules="(!account.UseBillingAddress && account.paymentMethodId === 'CC') ? CC_stateProvRules : []"
                  ></v-autocomplete>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.CC_mailCode"
                    value="postalZipCode"
                    label="Postal/Zip Code*"
                    :disabled="account.UseBillingAddress"
                    v-show="account.paymentMethodId === 'CC'"
                    :mask="CC_mailCodeMask"
                    return-masked-value
                    :required="!account.UseBillingAddress && account.paymentMethodId === 'CC'"
                    :rules="(!account.UseBillingAddress && account.paymentMethodId === 'CC') ? CC_mailCodeRules : []"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>

            <v-divider class="mr3"></v-divider>

            <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-4 mb-3>
              <v-layout hide-details justify-start row mt-0 mb-4>
                <v-flex hide-details mx-4 xs2>
                  <h3 class="text-xs-left ml-0 mt-1">General Account Information</h3>
                  <v-autocomplete
                    hide-details
                    :items="ddlAccountTypes"
                    v-model="account.accountType"
                    item-text="Text"
                    item-value="Value"
                    label="Account Type*"
                    :rules="accountTypeRules"
                    required
                    clearable
                  ></v-autocomplete>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.parentAccount"
                    value="parentAccount"
                    label="Parent Account"
                    @input="forceUpperCase('parentAccount')"
                  ></v-text-field>
                  <v-autocomplete
                    hide-details
                    :items="AROwnedBy"
                    v-model="account.arOwnedBy"
                    item-text="Text"
                    item-value="Value"
                    label="A/R Owned By*"
                    clearable
                    :disabled="account.parentAccount ? account.parentAccount.length === 0 : true"
                    :required="!(account.parentAccount ? account.parentAccount.length === 0 : true)"
                    :rules="!(account.parentAccount ? account.parentAccount.length === 0 : true) ? arOwnedByRules : []"
                  ></v-autocomplete>
                  <v-text-field
                    style="max-height: 45px; font-weight: bold;"
                    :style="cssProps"
                    class="status-colour"
                    v-model="account.AccountStatus"
                    value="accountStatus"
                    label="Status"
                    readonly
                  ></v-text-field>
                </v-flex>

                <v-flex hide-details mx-4 mr-5 xs2>
                  <h3 class="text-xs-left ml-0 mt-1" style="color: white;">-</h3>
                  <v-autocomplete
                    hide-details
                    :items="ddlInterestRates"
                    v-model="account.interestRateId"
                    item-text="Text"
                    item-value="Value"
                    label="Interest*"
                    :rules="interestRules"
                    required
                    clearable
                  ></v-autocomplete>
                  <v-autocomplete
                    hide-details
                    :items="ddlCreditTerms"
                    v-model="account.creditTermsId"
                    item-text="Text"
                    item-value="Value"
                    label="Credit Terms*"
                    :rules="creditTermRules"
                    required
                    clearable
                  ></v-autocomplete>
                  <v-autocomplete
                    hide-details
                    :items="ddlAccountClasses"
                    v-model="account.accountClassId"
                    item-text="Text"
                    item-value="Value"
                    label="Account Class*"
                    :rules="accountClassRules"
                    required
                    clearable
                  ></v-autocomplete>
                  <v-autocomplete
                    style="max-height: 45px"
                    hide-details
                    :items="ddlStatusActions"
                    v-model="account.StatusAction"
                    item-text="Text"
                    item-value="Value"
                    clearable
                    required
                    :rules="statusActionRules"
                  >
                    <template slot="label">
                      <div class="red--text">Status Action</div>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-divider vertical class="mt-2 mb-1"></v-divider>

                <v-flex hide-details mx-4 ml-5 xs2>
                  <h3 class="text-xs-left ml-0 mt-1">'Bill To' Contact</h3>
                  <v-autocomplete
                    hide-details
                    :items="ddlBillLanguages"
                    v-model="account.billTo_languageId"
                    item-text="Text"
                    item-value="Value"
                    label=" Contact Language*"
                    clearable
                    required
                    :rules="billTo_languageRules"
                  ></v-autocomplete>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.billTo_Name1"
                    value="billTo_Name1"
                    label="First Name*"
                    @input="forceUpperCase('billTo_Name1')"
                    required
                    :rules="billTo_Name1Rules"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.billTo_Name2"
                    value="billTo_Name2"
                    label="Last Name"
                    @input="forceUpperCase('billTo_Name2')"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.billTo_Email"
                    value="billTo_Email"
                    label="Email*"
                    @input="forceUpperCase('billTo_Email')"
                    required
                    :rules="billTo_EmailRules"
                  ></v-text-field>
                </v-flex>

                <v-flex hide-details mx-4 xs2>
                  <h3 class="text-xs-left ml-0 mt-1" style="color: white;">-</h3>

                  <v-layout>
                    <v-flex xs12 mr-3>
                      <v-text-field
                        style="max-height: 45px"
                        v-model="account.billTo_Phone"
                        value="billTo_Phone"
                        label="Phone"
                        :mask="phoneNumberMask"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        style="max-height: 45px"
                        v-model="account.billTo_PhoneExt"
                        value="billTo_PhoneExt"
                        label="Ext."
                        mask="##########"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex xs12 mr-3>
                      <v-text-field
                        style="max-height: 45px"
                        v-model="account.billTo_AltPhone"
                        value="billTo_AltPhone"
                        label="Alt. Phone"
                        :mask="phoneNumberMask"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        style="max-height: 45px"
                        v-model="account.billTo_AltPhoneExt"
                        value="billTo_AltPhoneExt"
                        label="Ext."
                        mask="##########"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.billTo_Fax"
                    value="billTo_Fax"
                    label="Fax"
                    :mask="phoneNumberMask"
                  ></v-text-field>
                  <v-text-field
                    style="max-height: 45px"
                    v-model="account.billTo_Cell"
                    value="billTo_Cell"
                    label="Cell"
                    :mask="phoneNumberMask"
                  ></v-text-field>
                </v-flex>

                <v-flex hide-details mx-4 xs2 style="margin-top: 73px; max-height: 151px;">
                  <h3 class="text-xs-left ml-0 mt-1" style="color: white;">-</h3>
                  <v-textarea
                    v-model="account.billTo_Notes"
                    value="billTo_Notes"
                    label="Notes"
                    @input="forceUpperCase('billTo_Notes')"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-layout>

            <v-divider class="mr3"></v-divider>

            <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-4>
              <v-layout hide-details justify-start row mt-0 mb-4>
                <v-flex hide-details mx-4 xs2>
                  <h3 class="text-xs-left ml-0 mt-1">Bill Publishing</h3>
                  <v-autocomplete
                    hide-details
                    :items="ddlInvoiceCycles"
                    v-model="account.invoiceCycleId"
                    item-text="Text"
                    item-value="Value"
                    label="Bill Cycle*"
                    :rules="billCycleRules"
                    required
                    clearable
                  ></v-autocomplete>
                  <v-autocomplete
                    hide-details
                    :items="ddlBillLanguages"
                    v-model="account.billLanguageId"
                    item-text="Text"
                    item-value="Value"
                    label="Bill Language*"
                    :rules="billLanguageRules"
                    required
                    clearable
                  ></v-autocomplete>
                  <v-autocomplete
                    hide-details
                    :items="ddlDeliveryMethods"
                    v-model="account.deliveryMethodId"
                    item-text="Text"
                    item-value="Value"
                    label="Delivery Method*"
                    :rules="deliveryMethodRules"
                    required
                    clearable
                  ></v-autocomplete>
                </v-flex>

                <v-flex hide-details mx-4 mr-5 xs2>
                  <h3 class="text-xs-left ml-0 mt-1">&nbsp;</h3>
                  <v-autocomplete
                    hide-details
                    :items="ddlManagementTypes"
                    v-model="account.managementReportTypeId"
                    item-text="Text"
                    item-value="Value"
                    label="Management Report*"
                    :rules="managementReportRules"
                    required
                    clearable
                  ></v-autocomplete>
                  <v-autocomplete
                    hide-details
                    :items="ddlCallDetailTypes"
                    v-model="account.callDetailReportTypeId"
                    item-text="Text"
                    item-value="Value"
                    label="Call Detail Report*"
                    :rules="callDetailReportRules"
                    required
                    clearable
                  ></v-autocomplete>
                </v-flex>

                <v-divider vertical class="mt-2 mb-1"></v-divider>

                <v-flex hide-details mx-4 ml-5>
                  <h3 class="text-xs-left ml-0 mt-1">Tax</h3>
                  <v-layout align-center>
                    <v-checkbox v-model="account.FederalTaxBool" hide-details class="shrink mr-2"></v-checkbox>
                    <v-text-field
                      v-model="account.FederalTaxText"
                      :disabled="account.FederalTaxBool"
                      label="Federal Tax"
                      hide-details
                    ></v-text-field>
                  </v-layout>

                  <v-layout align-center>
                    <v-checkbox v-model="account.StateTaxBool" hide-details class="shrink mr-2"></v-checkbox>
                    <v-text-field
                      v-model="account.StateTaxText"
                      :disabled="account.StateTaxBool"
                      label="State Tax"
                      hide-details
                    ></v-text-field>
                  </v-layout>
                </v-flex>

                <v-flex hide-details mx-4>
                  <h3 class="text-xs-left ml-0 mt-1" style="color: white;">-</h3>

                  <v-layout align-center>
                    <v-checkbox v-model="account.CountyTaxBool" hide-details class="shrink mr-2"></v-checkbox>
                    <v-text-field
                      v-model="account.CountyTaxText"
                      :disabled="account.CountyTaxBool"
                      label="Country Tax"
                      hide-details
                    ></v-text-field>
                  </v-layout>

                  <v-layout align-center>
                    <v-checkbox v-model="account.LocalTaxBool" hide-details class="shrink mr-2"></v-checkbox>
                    <v-text-field
                      v-model="account.LocalTaxText"
                      :disabled="account.LocalTaxBool"
                      label="Local Tax"
                      hide-details
                    ></v-text-field>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>

            <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0>
              <v-layout hide-details justify-end row mt-0>
                <v-flex hide-details justify-end mx-0 mt-0 xs3>
                  <a
                    class="align-center mx-4 pt-3"
                    style="text-decoration: none"
                    @click="cancel"
                  >CANCEL</a>
                  <v-btn color="success" @click="editAccount()" class="ml-2 mr-3">Save</v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import axios from "axios";
import Bus from "../../bus";

export default {
  name: "EditAccount",

  components: {
    Spinner
  },

  data: () => ({
    dialog: false,
    valid: true,

    creditCardHasMask: false,
    creditCardMask: "credit-card",
    creditCardExpiryMask: "## / ##",
    cardExpiryString: "",

    mailCodeMask: "",
    mailCodeRegex: "",

    CC_mailCodeMask: "",
    CC_mailCodeRegex: "",

    phoneNumberMask: "",

    ddlAccountTypes: [],
    ddlStateProvs: [],
    AROwnedBy: [
      { Value: "true", Text: "Account" },
      { Value: "false", Text: "Parent" }
    ],
    ddlInterestRates: [],
    ddlCreditTerms: [],
    ddlAccountClasses: [],
    ddlPaymentMethods: [],
    ddlBillLanguages: [],
    ddlInvoiceCycles: [],
    ddlManagementTypes: [],
    ddlCallDetailTypes: [],
    ddlDeliveryMethods: [],
    ddlStatusActions: [],
    ddlCCTypes: [],

    accountTypeRules: [v => !!v || ""],
    interestRules: [v => !!v || ""],
    creditTermRules: [v => !!v || ""],
    accountClassRules: [v => !!v || ""],
    paymentMethodRules: [v => !!v || ""],
    countryRules: [v => !!v || ""],
    billCycleRules: [v => !!v || ""],
    billLanguageRules: [v => !!v || ""],
    managementReportRules: [v => !!v || ""],
    callDetailReportRules: [v => !!v || ""],
    CCTypeRules: [v => !!v || ""],
    deliveryMethodRules: [v => !!v || ""],
    invoiceMediaRules: [v => (v && v.length > 0) || ""],
    Name1Rules: [v => !!v || ""],
    Address1Rules: [v => !!v || ""],
    cityNameRules: [v => !!v || ""],
    stateProvRules: [v => !!v || ""],
    mailCodeRules: [v => !!v || ""],
    ACH_BankAccountNameRules: [v => !!v || ""],
    CardNumberRules: [
      (v) => !!v || "Card Number is required",
      (v) => /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/.test(v) || "Invalid Card Number"
    ],
    CardholderNameRules: [v => !!v || ""],
    CardExpiryRules: [
      v => !!v || "",
      v => (v && v.length == 4) || "Invalid Card Expiry Date"
    ],
    ACH_BankAccountNumberRules: [v => !!v || ""],
    ACH_RoutingNumberRules: [v => !!v || ""],
    CC_Address1Rules: [v => !!v || ""],
    CC_CityRules: [v => !!v || ""],
    CC_stateProvRules: [v => !!v || ""],
    CC_mailCodeRules: [v => !!v || ""],
    CreditLimitRules: [v => !!v || ""],
    billTo_languageRules: [v => !!v || ""],
    billTo_Name1Rules: [v => !!v || ""],
    billTo_EmailRules: [
      v => !!v || "",
      v => /.+@.+\..+/.test(v) || "Email must be valid"
    ],
    arOwnedByRules: [v => !!v || ""],
    statusActionRules: [v => !!v || ""],

    account: {
      UseBillingAddress: false,
      StatusAction: "S0"
    }
  }),

  mounted() {
    this.initialize();
  },
  computed: {
    cssProps() {
      var statusColour = this.account.StatusColour;
      var statusColourOutput;

      if (typeof statusColour == "undefined" || statusColour == null) {
        statusColourOutput = "black";
      } else {
        statusColourOutput = statusColour;
      }

      var cssProps = {
        "--status-colour": statusColourOutput
      };
      return cssProps;
    }
  },

  methods: {
    initialize() {
      this.getDropDownLists();
    },
    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    // Get account info from DB to populate form
    async getAccountInfo(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },
    getDropDownLists() {
      axios.get("api/Account/GetEditAccountDdls").then(res => {
        this.ddlAccountTypes = res.data.ddlAccountTypes;
        this.ddlStateProvs = res.data.ddlStateProvs;
        this.ddlInvoiceCycles = res.data.ddlInvoiceCycles;
        this.ddlAccountClasses = res.data.ddlAccountClasses;
        this.ddlDeliveryMethods = res.data.ddlDeliveryMethods;
        this.ddlBillLanguages = res.data.ddlBillLanguages;
        this.ddlManagementTypes = res.data.ddlManagementTypes;
        this.ddlCallDetailTypes = res.data.ddlCallDetailTypes;
        this.ddlCreditTerms = res.data.ddlCreditTerms;
        this.ddlPaymentMethods = res.data.ddlPaymentMethods;
        this.ddlInterestRates = res.data.ddlInterestRates;
        this.ddlStatusActions = res.data.ddlStatusActions;
        this.ddlCCTypes = res.data.ddlCCTypes;
      });
    },
    async getMailCodeMask() {
      axios
        .get("api/Account/GetMailCodeMask/" + this.account.stateProvId)
        .then(resp => {
          if (resp.data !== " ") {
            this.mailCodeMask = resp.data.split(",")[0];
            this.mailCodeRegex = resp.data.split(",")[1];
            this.mailCodeRules = [
              v => !!v || "",
              v =>
                new RegExp(resp.data.split(",")[1]).test(v) ||
                "Not a valid Postal/Zip Code. Match format " +
                  resp.data.split(",")[2]
            ];
          } else {
            this.mailCodeMask = "";
            this.mailCodeRegex = "";
            this.mailCodeRules = [];
          }

          this.getPhoneNumberType();
        })
        .catch(err => console.log(err));
    },
    async getCCMailCodeMask() {
      axios
        .get("api/Account/GetMailCodeMask/" + this.account.CC_stateProvId)
        .then(resp => {
          if (resp.data !== " ") {
            this.CC_mailCodeMask = resp.data.split(",")[0];
            this.CC_mailCodeRegex = resp.data.split(",")[1];
            this.CC_mailCodeRules = [
              v => !!v || "",
              v =>
                new RegExp(resp.data.split(",")[1]).test(v) ||
                "Not a valid Postal/Zip Code. Match format " +
                  resp.data.split(",")[2]
            ];
          } else {
            this.CC_mailCodeMask = "";
            this.CC_mailCodeRegex = "";
            this.CC_mailCodeRules = [];
          }
        })
        .catch(err => console.log(err));
    },
    async getPhoneNumberType() {
      axios
        .get("api/Account/GetPhoneNumberType/" + this.account.stateProvId)
        .then(resp => {
          if (resp.data === "N") {
            this.phoneNumberMask = "(###) ###-####";
          } else {
            this.phoneNumberMask = "";
          }
        })
        .catch(err => console.log(err));
    },
    async open(item) {
      this.dialog = true;

      await this.getAccountInfo(
        "api/Account/GetEditAccountInfo/" + item.BAN,
        "account"
      );
      this.account.BAN = item.BAN;

      this.account.billTo_Email = this.account.billTo_Email
        ? this.account.billTo_Email.toUpperCase()
        : "";

      this.account.CardholderName = this.account.CardholderName
        ? this.account.CardholderName.toUpperCase()
        : "";
      this.cardExpiryString = this.getCardExpiryString();

      this.getMailCodeMask();

      if (this.account.CC_stateProvId) {
        this.getCCMailCodeMask();
      }

      //this.account.deliveryMethodId = '6'
    },
    cancel() {
      this.dialog = false;

      this.$refs.editAccountForm.resetValidation();

      this.creditCardHasMask = false;
      this.cardExpiryString = "";

      this.mailCodeMask = "";
      this.mailCodeRegex = "";
      this.mailCodeRules = [];

      this.CC_mailCodeMask = "";
      this.CC_mailCodeRegex = "";
      this.CC_mailCodeRules = [];

      this.phoneNumberMask = "";

      this.account = {
        UseBillingAddress: false,
        StatusAction: "S0"
      };
    },
    async editAccount() {
      if (this.$refs.editAccountForm.validate()) {
        let result = await this.saveAccountChangesToDB();

        if (result) {
          this.$root.$emit("initialize", this.initialize);

          Bus.$emit("alert", {
            color: "success",
            message: "Account Edited Successfully!"
          });

          this.cancel();
        }
        // window.location.reload();
      }
    },
    async saveAccountChangesToDB() {
      this.account.CardExpiry = new Date();
      if (this.account.paymentMethodId === "CC") {
        this.account.CardExpiry = this.getCardExpiry();
      }

      this.account.billTo_Email = this.account.billTo_Email
        ? this.account.billTo_Email.toLowerCase()
        : "";

      let result = await axios.post("api/Account/EditAccount", this.account);
      return result;
    },
    getCardExpiry() {
      let cardExpiryDate = new Date();
      cardExpiryDate.setDate(1);
      cardExpiryDate.setMonth(parseInt(this.cardExpiryString.slice(0, 2)));
      cardExpiryDate.setFullYear(
        parseInt(this.cardExpiryString.slice(2, 4)) + 2000
      );
      return cardExpiryDate;
    },
    getCardExpiryString() {
      let cardExpiryDate = new Date(this.account.CardExpiry);
      let month = cardExpiryDate
        ? cardExpiryDate.getMonth() > 10
          ? cardExpiryDate.getMonth().toString()
          : "0" + cardExpiryDate.getMonth().toString()
        : "";
      let year = cardExpiryDate
        ? cardExpiryDate
            .getFullYear()
            .toString()
            .slice(2, 4)
        : "";
      return month + year !== "00" ? month + year : null;
    },
    addCreditCardMask() {
      this.account.CardNumber = "";
      this.creditCardHasMask = true;
    },
    forceUpperCase(prop) {
      this.account[`${prop}`] = this.account[`${prop}`].toUpperCase();
    }
  }
};
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}

#pdf {
  overflow: hidden;
  height: 0;
}
#qaPdf {
  overflow: hidden;
  height: 0;
}
#pictureshidden {
  overflow: hidden;
  height: 0;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
.status-colour >>> .v-text-field__slot input {
  color: var(--status-colour);
}
</style>

